import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";
import {
  BooleanInput,
  CompanyLocationSelect,
  SystemCodeSelect
} from "../inputs";

const InventoryStorageDimForm = ({ inputs, onChange, editing, canModify }) => (
  <React.Fragment>
    <Column.Group>
      <Column>
        <Field kind="group">
          <Control expanded>
            <Label>Code</Label>
            <Input
              required
              autoComplete="new"
              disabled={editing}
              name="DimCode"
              type="text"
              value={inputs?.DimCode}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Description</Label>
            <Input
              autoComplete="new"
              name="DimDescription"
              type="text"
              value={inputs?.DimDescription}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              value={inputs?.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
    <Column.Group>
      <Column>
        <Control>
          <SystemCodeSelect
            icon="globe"
            label="Storage Type"
            lookup={{ Category: "Inventory", Code: "InvStorageDim" }}
            name="InvStorageDimRecIdRef"
            readOnly={editing && !canModify}
            size=""
            value={inputs?.InvStorageDimRecIdRef}
            onChange={onChange}
          />
        </Control>
      </Column>
      <Column>
        <Control>
          <CompanyLocationSelect
            required
            icon="globe"
            label="Company Location"
            name="CompanyLocRecIdRef"
            readOnly={editing && !canModify}
            value={inputs.CompanyLocRecIdRef}
            variables={{ Active: true }}
            onChange={onChange}
          />
        </Control>
      </Column>
    </Column.Group>
  </React.Fragment>
);

InventoryStorageDimForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool,
  canModify: PropTypes.bool
};

InventoryStorageDimForm.defaultProps = {
  inputs: {
    Active: true
  }
};
export default InventoryStorageDimForm;
